import React from "react";
import { useState, useEffect, useRef } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useContext } from "react";
import { SearchContext } from "./Contexts/Context";
import SakrebuloInternal from "./SakrebuloInternal";
import { getMemberBySlug } from "../service/service";

function SakrebuloMembers1() {
  const ref = useRef(null);
  const [width, setWidth] = useState(10);
  const { language } = useContext(SearchContext);
  const navigate = useNavigate();
  const { id } = useParams();
  const [member, setMember] = useState({});
  const [loading, setLoading] = useState(true);
  const [wevri, setWevri] = useState(null);

  useEffect(() => {
    const link = `https://khulo.gov.ge/api/members.php?`;
    fetch(link)
      .then((response) => response.json())
      .then((data) => {
        // console.log('data[id]', data[id])
        setMember(data[id]);
        // console.log(data)
        // console.log('news', news)

        // console.log('object keys menu', Object.keys(menu))
        //console.log('object entries news', Object.entries(data))
        // console.log(Object.entries(data).length)
      });
    // console.log('news', news)
    // console.log('news 0', news[0])
    // console.log(JSON.parse(localStorage.getItem('languageLink')))

    //console.log('sheicvala!')
    setLoading(false);
  }, []);
  const [menu, setMenu] = useState({});
  useEffect(() => {
    const link = "https://khulo.gov.ge/api/site_menu1.php";
    fetch(link)
      .then((response) => response.json())
      .then((data) => {
        // console.log('data.menu',data.menu)
        setMenu(data.menu);

        //  console.log('menu', menu)

        //  console.log('object entries', Object.entries(menu))

        Object.entries(menu).map((item) => {
          if (item[1].level == 1) {
            //console.log('entries item', item[1].name_eng , item[1].level)
          }
        });
      });
  }, []);
  const presscenterList = Object.entries(menu).length
    ? Object.entries(menu).map((item, index) => {
        if (item[1].level == 1 && item[1].name_geo == "საკრებულო") {
          return Object.entries(menu).map((qveItem, index) => {
            if (qveItem[1].parent_id == item[1].cat_id) {
              const windoww = window.location.pathname;
              const result = windoww.split("/").pop();
              const slugg = qveItem[1].slug;
              return (
                <span key={index} className={result === slugg ? "active" : ""}>
                  <Link to={`/${qveItem[1].slug}`}>
                    {language == 1 ? qveItem[1].name_geo : qveItem[1].name_eng}
                  </Link>
                </span>
              );
            }
          });
        }
      })
    : "LOADING";

  const menuName = Object.entries(menu).length
    ? Object.entries(menu).find((item, index) => {
        const windoww = window.location.pathname;
        const result = windoww.split("/")[1];

        const slugg = item[1].slug;

        if (result == slugg) {
          return language == 1 ? item[1].name_geo : item[1].name_eng;
        }
      })
    : "";

  //console.log('object entries member' ,Object.entries(member))

  const memberFC = async (id) => {
    await getMemberBySlug(id).then((data) => {
      setWevri(data);
      setLoading(false);
    });
  };

  useEffect(() => {
    memberFC(id);
  }, [id]);

  if (loading) return <h1>LOADING</h1>;
  return (
    <motion.div
      intial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <div className="news-container margin-280px">
        <header>
          <span className="big">
            {" "}
            {language === 1 ? "საკრებულო" : "KHULO CITY ASSEMBLY"}
          </span>
          <span className="norm members1">საკრებულოს წევრები</span>
          <span className="">{wevri?.full_name}</span>
        </header>

        {wevri ? (
          <SakrebuloInternal
            presscenterList={presscenterList}
            image={wevri?.image}
            full_name={wevri?.full_name}
            position={wevri?.memberships[0]?.position_name}
            email={wevri?.email}
            mobile={wevri?.mobile}
            description={wevri?.description}
            socials={wevri?.socials}
            language={wevri}
          />
        ) : (
          <h1> LOADING</h1>
        )}
      </div>
    </motion.div>
  );
}

export default SakrebuloMembers1;
